var global = require('../internals/global');
var createNonEnumerableProperty = require('../internals/create-non-enumerable-property');

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/set-global.js
// module id = 252
// module chunks = 0